<template>
  <v-container fluid class="container_bg">

    <v-row align="center" justify="start" class="mt-5">
      <v-col cols="12" md="3" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
    </v-row>

    <div class="setting-wrap">

      <div class="cards">

        <!-- 상품 마진율 -->
        <section class="setting-card">
          <div class="card-head">
            <h3>Margin Rate<span>상품 마진율</span></h3>
            <p>카테고리별 도매 / 소매 마진율</p>
          </div>
          <div class="grid-3 grid-head">
            <span>구분</span><span>도매</span><span>소매</span>
          </div>
          <div class="grid-3 grid-row" v-for="item in marginFields" :key="item.whole">
            <div class="row-label">{{ item.label }}</div>
            <v-text-field
              class="none_radius num-field" color="black"
              single-line v-model="editedItem[item.whole]"
              height="40" outlined dense hide-details/>
            <v-text-field
              class="none_radius num-field" color="black"
              single-line v-model="editedItem[item.retail]"
              height="40" outlined dense hide-details/>
          </div>
        </section>

        <!-- 금시세표 살 때 / 팔 때 계수 (가격 = 돈당 국제시세 × 계수) -->
        <section class="setting-card">
          <div class="card-head">
            <h3>Gold Price Rate<span>금시세표 살 때 / 팔 때 계수</span></h3>
            <p>가격 = 돈당 국제시세 × 계수 (예: 1.18 = 118%, 0.9 = 90%)<br>소수점 4자리까지 · 비워두면 금시세표에 — 로 표시</p>
          </div>
          <div class="grid-3 grid-head">
            <span>품목</span><span>살 때</span><span>팔 때</span>
          </div>
          <div class="grid-3 grid-row" v-for="item in margins" :key="item.ITEM_KEY">
            <div class="row-label">{{ item.NAME }}</div>
            <v-text-field
              class="none_radius num-field" color="black"
              single-line v-model="item.BUY_RATE" placeholder="—"
              height="40" outlined dense hide-details/>
            <v-text-field
              class="none_radius num-field" color="black"
              single-line v-model="item.SELL_RATE" placeholder="—"
              height="40" outlined dense hide-details/>
          </div>
        </section>

        <!-- 환율 · 입금 계좌 -->
        <section class="setting-card full">
          <div class="card-head">
            <h3>Payment<span>환율 · 입금 계좌</span></h3>
          </div>
          <div class="pay-grid">
            <div>
              <label class="field-label">Exchange Rate<small>환율</small></label>
              <v-text-field
                class="none_radius num-field" color="black"
                single-line v-model="editedItem.EXCHANGE"
                height="40" outlined dense hide-details/>
              <p class="field-hint">30분마다 원/달러 환율로 자동 갱신됩니다.<br>직접 입력한 값은 다음 갱신 때 바뀝니다.</p>
            </div>
            <div>
              <label class="field-label">Bank account number<small>계좌번호</small></label>
              <v-textarea
                class="none_radius" color="black"
                single-line v-model="editedItem.BANKNUMBER"
                height="80" outlined dense hide-details no-resize/>
            </div>
          </div>
        </section>

      </div>

      <!-- 위 모든 설정을 한 번에 저장 -->
      <div class="save-bar">
        <v-btn elevation="0" class="black_btn" width="100%" height="50px" :loading="saving" @click="save">Save 저장</v-btn>
      </div>

    </div>

  </v-container>
</template>
<script>
import cmvalidation from '../assets/js/cmvalidation.js'
export default {

    mounted() {
      if(this.$session.get("GRADE") < 90){
        this.showalert("Page of permissions not available.<br><br>사용할 수 없는 권한의 페이지입니다.").then(r => {
          if(r.value){
            this.$router.back();
          }
        });
        return;
      }

      if(this.$session.exists("ACCNT_IDX")){
        this.loadpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("/Login");
      }

    },

    data: () => ({

      editedItem:{},    //SETTINGVALUE (마진율, 환율, 계좌번호)
      margins:[],       //PRICE_MARGIN (금시세표 살 때 / 팔 때 계수)
      saving:false,

      //상품 마진율 입력 항목
      marginFields:[
          {label:'다이아몬드',          whole:'DIAWHOLE',    retail:'DIARETAIL'}
        , {label:'렙-그로운 다이아몬드', whole:'FDIAWHOLE',   retail:'FDIARETAIL'}
        , {label:'젬스톤',             whole:'GEMWHOLE',    retail:'GEMRETAIL'}
        , {label:'주얼리',             whole:'JEWELYWHOLE', retail:'JEWELYRETAIL'}
        , {label:'세공',               whole:'CRAFTWHOLE',  retail:'CRAFTRETAIL'}
      ],

    }),

    methods: {

      back(){
        this.$router.back();
      },

      showalert(html){
        return this.$fire({
          html: html,
          confirmButtonText:"<div style='font-size:14px;line-height:15px'>Confirm<br>확인</div>",
          confirmButtonColor: '#000000',
          allowEscapeKey:false,
          allowOutsideClick:false,
          allowEnterKey:true,
        });
      },

      headers(){
        return {headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}};
      },

      //토큰 갱신값 저장, 재로그인이 필요하면 false
      checkresult(result){
        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
        }
        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
        }
        if(result.data.resultCode == 2){
          this.showalert("Please log in again due to token expiration.<br><br>토큰 만료로 인해 다시 로그인해주세요.").then(r => {
            if(r.value){
              this.$EventBus.$emit('clearsession');
            }
          });
          return false;
        }
        return true;
      },

      showerror(error){
        if(error.message == 'Request failed with status code 429'){
          this.showalert("Please try it later due to many requests.<br><br>많은 요청으로 인해 잠시 후 시도해주세요.");
        }else{
          this.showalert(error.message);
        }
      },

      //설정값 + 금시세표 계수 조회
      async loadpage(){
        try {
          const setting = await this.$http.post(this.$host+'/SettingValue',{}, this.headers());
          if(!this.checkresult(setting)) return;
          if(setting.data.resultCode == 0){
            this.editedItem = setting.data.resultData[0];
          }

          const margin = await this.$http.post(this.$host+'/PriceMargin',{}, this.headers());
          if(!this.checkresult(margin)) return;
          if(margin.data.resultCode == 0){
            this.margins = margin.data.resultData;
          }else{
            this.showalert("Failed to load gold price rates.<br><br>금시세표 계수를 불러오지 못했습니다.");
          }
        } catch (error) {
          this.showerror(error);
        }
      },

      //입력값 검사 - 오류가 있으면 안내 문구, 없으면 null
      validate(){
        const checkrate = "Please check the margin rate.<br><br>";
        for(const item of this.marginFields){
          for(const [field, name] of [[item.whole, '도매'], [item.retail, '소매']]){
            const label = item.label + ' ' + name + ' 마진율';
            const check = cmvalidation.checkValReg(this.editedItem[field], /[^0-9.]/g, -1, -1);
            if(check == 1) return checkrate + label + '을 입력하세요.';
            if(check == 2) return checkrate + label + '은 숫자와 .만 입력할 수 있습니다.';
            if(Number(this.editedItem[field]) <= 0) return checkrate + label + '은 0보다 커야 합니다.';
          }
        }

        const checkexchange = cmvalidation.checkValReg(this.editedItem.EXCHANGE, /[^0-9.]/g, -1, -1);
        if(checkexchange == 1) return "Enter the exchange rate<br><br>환율을 입력하세요.";
        if(checkexchange == 2) return "exchange rate can only be numeric and .<br><br>환율은 숫자와 .만 입력할 수 있습니다.";

        const checkbank = cmvalidation.checkValReg(this.editedItem.BANKNUMBER, null, 8, 100);
        if(checkbank == 1) return "Enter the Bank account number<br><br>계좌번호를 입력하세요.";
        if(checkbank == 3) return "Please enter at least 8 characters of bank account number<br><br>계좌번호는 8자 이상 입력하세요.";
        if(checkbank == 4) return "Please enter your bank account number in 100 characters or less<br><br>계좌번호는 100자 이하로 입력하세요.";

        //금시세표 계수 - 빈 값 허용, 0보다 크고 10 이하, 소수점 4자리까지 (DB DECIMAL(8,4))
        const validrate = value => value == null || String(value).trim() == '' || (/^\d+(\.\d{1,4})?$/.test(String(value).trim()) && Number(value) > 0 && Number(value) <= 10);
        const wrong = this.margins.find(item => !validrate(item.BUY_RATE) || !validrate(item.SELL_RATE));
        if(wrong) return "Rates must be numbers greater than 0 and up to 10, with up to 4 decimal places.<br><br>" + wrong.NAME + " 계수는 0보다 크고 10 이하, 소수점 4자리까지만 입력할 수 있습니다. (예: 1.18, 0.6903)";

        return null;
      },

      //마진율·환율·계좌번호와 금시세표 계수를 한 번에 저장
      async save(){
        const message = this.validate();
        if(message){
          this.showalert(message);
          return;
        }

        const setting = {
            EXCHANGE:   this.editedItem.EXCHANGE
          , BANKNUMBER: escape(this.editedItem.BANKNUMBER)
        };
        this.marginFields.forEach(item => {
          setting[item.whole]  = this.editedItem[item.whole];
          setting[item.retail] = this.editedItem[item.retail];
        });

        this.saving = true;
        try {
          const result1 = await this.$http.post(this.$host+'/SettingValueUpdate', setting, this.headers());
          if(!this.checkresult(result1)) return;
          if(result1.data.resultCode != 0){
            this.showalert("Failed to save.<br><br>설정 저장에 실패했습니다.");
            return;
          }

          const result2 = await this.$http.post(this.$host+'/PriceMarginUpdate',{
            items: this.margins.map(item => ({ITEM_KEY:item.ITEM_KEY, BUY_RATE:item.BUY_RATE, SELL_RATE:item.SELL_RATE}))
          }, this.headers());
          if(!this.checkresult(result2)) return;
          if(result2.data.resultCode != 0){
            this.showalert("Settings were saved, but gold price rates failed to save.<br><br>마진율·환율·계좌번호는 저장되었지만 금시세표 계수 저장에 실패했습니다.");
            return;
          }

          const r = await this.showalert("The modification is complete.<br><br>수정이 완료되었습니다.");
          if(r.value){
            this.loadpage();
          }
        } catch (error) {
          this.showerror(error);
        } finally {
          this.saving = false;
        }
      },

    },

}
</script>

<style scoped>

.setting-wrap{
  max-width:760px;
  margin:8px auto 0;
}

/* 카드는 1열로 세로 배치 */
.cards{
  display:grid;
  grid-template-columns:1fr;
  gap:20px;
}

.setting-card{
  background:#ffffff;
  border:1px solid #e3e3e3;
  padding:24px;
  min-width:0;
}
.setting-card.full{
  grid-column:1 / -1;
}

.card-head{
  margin-bottom:16px;
}
.card-head h3{
  margin:0;
  font-size:18px;
  font-weight:700;
  color:#000000;
}
.card-head h3 span{
  margin-left:8px;
  font-size:14px;
  font-weight:400;
  color:#777777;
}
.card-head p{
  margin:6px 0 0;
  font-size:13px;
  color:#888888;
  line-height:1.6;
}

/* 구분 | 값1 | 값2 */
.grid-3{
  display:grid;
  grid-template-columns:minmax(0,1.3fr) minmax(0,1fr) minmax(0,1fr);
  gap:10px;
  align-items:center;
}
.grid-head{
  padding-bottom:8px;
  border-bottom:2px solid #000000;
  font-size:12px;
  font-weight:600;
  color:#555555;
}
.grid-row{
  padding:8px 0;
  border-bottom:1px solid #f0f0f0;
}
.grid-row:last-child{
  border-bottom:0;
}
.row-label{
  font-size:14px;
  font-weight:600;
  color:#222222;
  word-break:keep-all;
}

.num-field ::v-deep input{
  text-align:right;
}

.pay-grid{
  display:grid;
  grid-template-columns:minmax(0,1fr) minmax(0,2fr);
  gap:20px;
}
.field-label{
  display:block;
  margin-bottom:6px;
  font-size:13px;
  font-weight:600;
  color:#333333;
}
.field-label small{
  margin-left:6px;
  font-size:12px;
  font-weight:400;
  color:#888888;
}
.field-hint{
  margin:6px 0 0;
  font-size:12px;
  line-height:1.5;
  color:#888888;
}

.save-bar{
  display:flex;
  justify-content:center;
  margin:28px 0 40px;
}
.save-bar .v-btn{
  max-width:480px;
}

@media (max-width:960px){
  .pay-grid{grid-template-columns:1fr;gap:14px}
}
@media (max-width:600px){
  .setting-card{padding:16px}
  .grid-3{gap:6px}
  .row-label{font-size:13px}
  .card-head h3{font-size:16px}
  .card-head h3 span{display:block;margin:2px 0 0}
}

</style>
